// Vue & Vuex
import Vue from "vue";
import Vuex from "vuex";

// Constants
import { CLIENT_ID, Tenant, Redirect_Uri } from "@/config/constant";

// Initializing Vuex
Vue.use(Vuex);

/**
 * @description Store contains MSAL Config, Token Details & User Details
 */
export const store = new Vuex.Store({
  state: {
    msalConfig: {
      auth: {
        clientId: CLIENT_ID,
        authority: `https://login.microsoftonline.com/${Tenant}/`,
        navigateToLoginRequestUrl: true,
        redirectUri: Redirect_Uri,
        postLogoutRedirectUri: Redirect_Uri,
      },
      cache: {
        cacheLocation: "sessionStorage",
      },
    },
    tokenConfiguration: {},
    user: {},
    idToken: {},
    isEditor: false,
    isSupport: false,
    isIndexer: false,
    isViewer: false,
  },
  actions: {
    setAccessTokenAction({ commit }, token) {
      commit("setAccessToken", token);
    },
    setIdTokenAction({ commit }, idToken) {
      commit("setIdToken", idToken);
    },
    setIsEditorAction({ commit }, value) {
      commit("setIsEditor", value);
    },
    setIsSupportAction({ commit }, value) {
      commit("setIsSupport", value);
    },
    setIsIndexerAction({ commit }, value) {
      commit("setIsIndexer", value);
    },
    setUserDataAction({ commit }, token) {
      commit("setUserData", token);
    },
    setIsViewerAction({ commit }, token) {
      commit("setIsViewer", token);
    },
  },
  mutations: {
    setAccessToken(state, token) {
      state.tokenConfiguration = token;
    },
    setIdToken(state, idToken) {
      state.idToken = idToken;
    },
    setIsEditor(state, value) {
      state.isEditor = value;
    },
    setIsSupport(state, value) {
      state.isSupport = value;
    },
    setIsIndexer(state, value) {
      state.isIndexer = value;
    },
    setUserData(state, userData) {
      state.user = userData;
    },
    setIsViewer(state, value) {
      state.isViewer = value;
    },
  },
  getters: {
    getTokenData(state) {
      return state.tokenConfiguration;
    },
    getIdToken(state) {
      return state.idToken;
    },
    getIsEditor(state) {
      return state.isEditor;
    },
    getIsSupport(state) {
      return state.isSupport;
    },
    getIsIndexer(state) {
      return state.isIndexer;
    },
    getUserData(state) {
      return state.user;
    },
    getIsViewer(state) {
      return state.isViewer;
    },
  },
});
